import React from 'react';
import { Link } from 'react-router-dom';
import selectors from '@/vocabularies/hooks/selectors';
import HomeLogo from './HomeLogo';

const HomeLink = () => {
  const { href } = selectors.useHomeLink();
  if (href === '/') {
    return (
      <Link to={href} className="header item aridhia-home-logo">
        <HomeLogo />
      </Link>
    );
  }

  return (
    <a href={href} rel="noopener noreferrer" className="header item aridhia-home-logo">
      <HomeLogo />
    </a>
  );
};

export default HomeLink;
